import styled from 'styled-components';

export interface IMarginerProps {
  margin: number | string;
  direction?: 'horizontal' | 'vertical';
}

const HorizontalMargin = styled.span<{ $margin: number | string }>`
  display: flex;
  min-width: ${({ $margin }) => (typeof $margin === 'string' ? $margin : `${$margin}px`)};
`;

const VerticalMargin = styled.span<{ $margin: number | string }>`
  display: flex;
  min-height: ${({ $margin }) => (typeof $margin === 'string' ? $margin : `${$margin}px`)};
`;

function Marginer({ direction = 'horizontal', margin }: IMarginerProps) {
  if (direction === 'horizontal') return <HorizontalMargin $margin={margin} />;
  else {
    return <VerticalMargin $margin={margin} />;
  }
}

export { Marginer };
